(function () {
  angular.module('kareo.ui.shared.services.therapy-cap', [])
    .factory('therapyCapService', TherapyCapService);

  TherapyCapService.$inject = ['$http'];

  function TherapyCapService($http) {
    return {
      getProviderSpeciality
    };

    function getProviderSpeciality(providerId) {
      const url = '/dashboard-calendar-ui/api/Provider/specialty';
      const params = {};
      if (providerId) {
        params.providerId = providerId;
      }
      return $http.get(url, { params, cache: true })
      .then((response) => {
        return response.data;
      });
    }
  }
})();
